import React, { useState, useEffect } from 'react';
import { MdOutlineCategory } from "react-icons/md";
import { SlLocationPin } from "react-icons/sl";
import { BsBoxSeam } from "react-icons/bs";
import { USER_URL } from '../../constant/api';
import Loader from '../../components/Loader/Loader';

const InputField = ({ type, placeholder, icon: Icon, className, ...rest }) => {
  return (
    <div className={`relative ${className}`}>
      {Icon && <Icon className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-400" />}
      <input
        type={type}
        placeholder={placeholder}
        className="p-2 pl-5 border border-gray-300 rounded-md w-full"
        {...rest}
      />
    </div>
  );
};

const Button = ({ children, className, ...rest }) => {
  return (
    <button
      className={`bg-green-500 text-white p-2 rounded-md hover:bg-green-600 ease-in-out duration-500 ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
};

function SubAdminOrderReport() {
  const [sales, setSales] = useState([]);
  const [filteredSales, setFilteredSales] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [startDate, setStartDate] = useState('');
  const [orderNumber, setOrderNumber] = useState('');
  const [area, setArea] = useState('');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await USER_URL.get(`/orders/subadmin/orders/`);
        let sortedData = response.data.Data.sort((a, b) => new Date(b.order_date) - new Date(a.order_date));
        setSales(sortedData);
        setFilteredSales(sortedData);
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchProducts();
  }, []);

  const handleSearch = () => {
    let filteredData = [...sales];
    if (startDate) {
      filteredData = filteredData.filter(order => order.order_date === startDate);
    }
    if (orderNumber) {
      filteredData = filteredData.filter(order => order.order_number.toLowerCase().includes(orderNumber.toLowerCase()));
    }
    if (area) {
      filteredData = filteredData.filter(order => order.place.toLowerCase().includes(area.toLowerCase()));
    }
    filteredData.sort((a, b) => new Date(b.order_date) - new Date(a.order_date));
    setFilteredSales(filteredData);
  };

  return (
    <div>
      <div className="max-w-md mt-5">
        <h1 className="text-2xl font-medium text-green-600 mb-4">Order Report</h1>
        <div className="grid grid-cols-4 gap-4">
          <InputField type="date" className="col-span-2" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          <InputField type="text" placeholder="Order Number" icon={MdOutlineCategory} className="col-span-2" value={orderNumber} onChange={(e) => setOrderNumber(e.target.value)} />
          <InputField type="text" placeholder="Area" icon={SlLocationPin} className="col-span-2" value={area} onChange={(e) => setArea(e.target.value)} />
          <Button className="col-span-2" onClick={handleSearch}>Search</Button>
        </div>
      </div>
      <div className="overflow-x-auto mt-5">
        {isLoading ? (
          <Loader />
        ) : filteredSales.length === 0 ? (
          <div className="text-center mt-10">
            <BsBoxSeam className="text-6xl text-gray-400 mx-auto mb-4" />
            <p className="text-lg text-gray-600">No sales available</p>
          </div>
        ) : (
          <>
            <div className="min-w-[800px] grid grid-cols-[2fr,2fr,2fr,2fr,1fr] font-medium text-brand-button-green-bg">
              <div className="text-center">Order Date</div>
              <div className="text-center">Invoice No</div>
              <div className="text-center">Place</div>
              <div className="text-center">Total Amount</div>
              <div className="text-center">Status</div>
            </div>
            {filteredSales.map((order) => (
              <div key={order.order_number} className="grid text-[#2F2E41] min-w-[800px] grid-cols-[2fr,2fr,2fr,2fr,1fr] items-center gap-2 py-2">
                <div className="border p-2 rounded-xl text-center">{order.order_date}</div>
                <div className="border p-2 rounded-xl text-center">{order.order_number}</div>
                <div className="border p-2 rounded-xl text-center">{order.place}</div>
                <div className="border p-2 rounded-xl text-center">₹{order.total_amount}</div>
                <div className="border p-2 rounded-xl text-center">{order.order_status}</div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}

export default SubAdminOrderReport